import axios from 'axios';
import { toast } from 'react-toastify';
import Cookies from 'universal-cookie';
import { VENDOR_NAME_KEY } from '~/theme/vendorConstants';

type Configuration = {
  url: string;
  data?: Object;
  skipAuthHeader?: boolean;
};

export default function createService(configuration: Configuration) {
  const cookies = new Cookies();
  const instance = axios.create({
    baseURL: configuration.url,
    data: configuration.data
  });

  instance.interceptors.request.use((req) => {
    const skipAuthHeader = Boolean(req.headers?.skipAuthHeader);
    if (skipAuthHeader) {
      (req as any).skipAuthHeader = true;
    }
    if (!skipAuthHeader && !configuration.skipAuthHeader) {
      const token = cookies.get('token') || sessionStorage.getItem('token');
      if (token) {
        req.headers = { ...(req.headers || {}), token };
      }
    }

    if (req?.data) {
      delete req.data.createdAt;
      delete req.data.updatedAt;
    }

    if (!req.headers) req.headers = {};
    if (req.headers.skipAuthHeader) {
      delete req.headers.skipAuthHeader;
    }
    req.headers['client'] = 'PM_DASHBOARD';
    return req;
  });

  instance.interceptors.response.use(
    (res) => {
      if (res.data.token) {
        cookies.set('token', res.data.token, { path: '/', httpOnly: false });
      }
      return res;
    },
    function (error) {
      if (
        error?.response?.status === 503 &&
        error?.response?.headers?.['x-maintenance-mode'] === 'true'
      ) {
        window.dispatchEvent(new Event('maintenance-mode'));
        return new Promise(() => {});
      }

      let message = '';
      let status = error?.response?.status;

      if (error?.response?.data?.message) {
        message = error?.response?.data?.message;
      }

      if (status) {
        if (status === 401) {
          const shouldSkipRedirect = Boolean((error as any)?.config?.skipAuthHeader);
          cookies.remove('token');
          sessionStorage.removeItem('token');
          sessionStorage.removeItem(VENDOR_NAME_KEY);
          if (!shouldSkipRedirect && window.location.pathname !== '/login') {
            window.location.href = '/login';
          }
        }

        if (status === 400) {
          toast(message || 'We couldn’t process your request. Please check your details and try again.');
        }

        if (status === 500) {
          toast(message || 'Something went wrong. Please try again.');
        }
      } else {
        status = 999;
      }

      const customError: Object = { status: status, message: message };
      throw customError;
    }
  );
  return {
    get: instance.get,
    post: instance.post,
    patch: instance.patch,
    delete: instance.delete,
    put: instance.put
  };
}
